import { store } from '@src/state/store';
import {
  getCurrentGame,
  getPlayerDataFromCurrentGame,
  getPlayerId,
} from '@src/state/selectors/selector_game';
import { pushEventQueue } from '@src/state/slices/slice_game';

import { Game } from '@src/lib/types';

export default () => (data: any) => {
  if (
    !data ||
    !data.gameId ||
    !data.playerId ||
    data.playerIndex === undefined ||
    data.playerIndex === null
  )
    return;

  const currentGame: Game | null = getCurrentGame(store.getState());
  if (currentGame === null)
    throw new Error('[_playerDrawingCard] game not found in root state');

  const playerId = getPlayerId(store.getState());

  // don't show this event if it's the current player drawing a card
  if (playerId === data.playerId) return;

  const playerData = getPlayerDataFromCurrentGame(
    store.getState(),
    data.playerId,
  );

  const message = playerData
    ? `${playerData.name} DREW A CARD`
    : `${data.playerId.slice(0, 7)} DREW A CARD`;

  if (data.gameId === currentGame.gameId) {
    console.log('PLAYER DRAWING CARD');
    store.dispatch(
      pushEventQueue({
        message,
        showToast: true,
        sound: 'drewCard',
      }),
    );
  }
};
